var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoinBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 50,
    viewBox: "0 0 47 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.351562,
    y: 0.000305176,
    width: 46,
    height: 50,
    fill: "#101010"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: "35%",
    y: "35%",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "translate(-50%, -50%)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.832169C6.77614 0.832169 7 1.05603 7 1.33217V6.00017H11.668C11.9441 6.00017 12.168 6.22403 12.168 6.50017C12.168 6.77631 11.9441 7.00017 11.668 7.00017H7V11.668C7 11.9441 6.77614 12.168 6.5 12.168C6.22386 12.168 6 11.9441 6 11.668V7.00017H1.332C1.05586 7.00017 0.832001 6.77631 0.832001 6.50017C0.832001 6.22403 1.05586 6.00017 1.332 6.00017H6V1.33217C6 1.05603 6.22386 0.832169 6.5 0.832169Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinBlack);
export default __webpack_public_path__ + "static/media/join_black.ae0da400e58691bb6d1326c7c84044b3.svg";
export { ForwardRef as ReactComponent };